const LoaderStore = {
  namespaced: true,
  state: {
    display: false
  },
  mutations: {
    display (state) {
      state.display = true
    },
    hide (state) {
      state.display = false
    }
  },
  actions: {
    displayLoader (context) {
      context.commit('display')
    },
    hideLoader (context) {
      context.commit('hide')
    }
  }
}

export default LoaderStore
